import React, { useState } from "react";
import {
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Button,
    Spinner,
} from "reactstrap";

/**
 * SubscriptionDeleteModal – Abonelik yonetimi silme onay modali
 *
 * Props
 * ─────────────────────────────────────────────────────────
 * @param {boolean}  isOpen      – Modal acik mi?
 * @param {Function} toggle      – Modal'i kapat/ac
 * @param {string}   title       – Modal baslik ("Paket Silme Onayi")
 * @param {string}   icon        – Boxicon sinifi ("bx-package")
 * @param {string}   message     – Onay mesaji
 * @param {Object}   item        – Silinecek oge (id alani olmali)
 * @param {Function} renderInfo  – Oge detaylarini gosteren render fonksiyonu
 * @param {Function} onConfirm   – Silme onaylandiginda calisir (id) => Promise
 */
export const SubscriptionDeleteModal = ({
    isOpen,
    toggle,
    title = "Silme Onayı",
    icon = "bx-trash",
    message = "Bu kaydı kalıcı olarak silmek istediğinizden emin misiniz?",
    item,
    renderInfo,
    onConfirm,
}) => {
    const [deleting, setDeleting] = useState(false);

    if (!item) return null;

    const handleConfirm = async () => {
        if (!onConfirm || !item.id) return;
        setDeleting(true);
        try {
            await onConfirm(item.id);
        } catch (error) {
            console.error("Silme hatası:", error);
        } finally {
            setDeleting(false);
        }
    };

    return (
        <Modal isOpen={isOpen} toggle={toggle} centered>
            <ModalHeader toggle={toggle} className="border-bottom">
                <div className="d-flex align-items-center gap-2 text-danger">
                    <i className={`bx ${icon} fs-4`}></i>
                    {title}
                </div>
            </ModalHeader>

            <ModalBody className="py-4">
                <div className="text-center mb-4">
                    <div className="mb-3">
                        <i className={`bx ${icon} display-4 text-muted`}></i>
                    </div>
                    <p className="text-muted mb-2">{message}</p>
                </div>

                {renderInfo && (
                    <div className="border rounded p-3 bg-light">
                        {renderInfo(item)}
                    </div>
                )}
            </ModalBody>

            <ModalFooter className="border-top">
                <div className="d-flex justify-content-end gap-2 w-100">
                    <Button
                        color="secondary"
                        onClick={toggle}
                        disabled={deleting}
                        className="rounded-pill px-4"
                    >
                        İptal
                    </Button>
                    <Button
                        color="danger"
                        onClick={handleConfirm}
                        disabled={deleting}
                        className="rounded-pill px-4 d-flex align-items-center gap-2"
                        style={{ minWidth: "110px" }}
                    >
                        {deleting ? (
                            <>
                                <Spinner size="sm" />
                                Siliniyor...
                            </>
                        ) : (
                            <>
                                <i className="bx bx-trash"></i>
                                Evet, Sil
                            </>
                        )}
                    </Button>
                </div>
            </ModalFooter>
        </Modal>
    );
};
